export var interactiveButtonTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 'xs',
      backgroundColor: 'brand.main',
      borderRadius: 'l',
      paddingX: '12px',
      maxWidth: '40px',
      height: '40px',
      overflow: 'hidden',
      transition: 'max-width 0.2s ease-in-out, padding 0.2s ease-in-out, outline-color 0.2s',
      outlineColor: 'transparent',
      _hover: {
        backgroundColor: 'brand.dark',
        paddingInlineEnd: 's',
        minWidth: '40px',
        maxWidth: '488px',
        svg: {
          transform: 'rotate(-180deg)',
          transition: 'transform 0.2s ease-out 0.1s'
        }
      },
      _active: {
        backgroundColor: 'brand.darkest'
      },
      _focusVisible: {
        outlineColor: 'focus.focus',
        outlineWidth: '2px',
        outlineOffset: '2px',
        outlineStyle: 'solid'
      }
    },
    text: {
      color: 'neutral.white',
      textStyle: 'body3Semi',
      overflow: 'hidden',
      marginInlineEnd: 'xxs',
      whiteSpace: 'nowrap'
    }
  }
};
//# sourceMappingURL=InteractiveButton.theme.js.map